import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id 42A6B073-CC7E-4539-9313-E60FAE81BC70
 * name chart-ppf
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chart-ppf.svg
 * tags
 * - Math 
 */
export const ChartPpfIcon = createSvgIcon(<><path d="M5 6V8C8.2 8 11.36 9.18 13.57 11.15C15.64 13 16.83 15.5 17 18H18.97A14 12.5 0 0 0 5 6M22 21H2V3H4V19H22Z" /></>, 'ChartPpfIcon');
export default ChartPpfIcon